module.exports = __webpack_public_path__ + "img/peopletree.2e9a45c2.png";